<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0"
        >สถานที่ลงเวลานอกบริษัท</span
      >
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!formShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::offsite_location:create')
            "
            style="margin-top: 1px"
            color="primary"
            @click="handleAddForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มสถานที่
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="offSiteLocations"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.latitude="{ item }">
        {{
          item.latitude.split('.')[0] +
          item.latitude.substr(item.latitude.indexOf('.'), 6)
        }}
      </template>
      <template v-slot:item.longitude="{ item }">
        {{
          item.longitude.split('.')[0] +
          item.longitude.substr(item.longitude.indexOf('.'), 6)
        }}
      </template>
    </v-data-table>
    <OffSiteLocationForm
      :formShow="formShow"
      :formAction="formAction"
      :offSiteLocation="offSiteLocation"
      :offSiteLocationInit="offSiteLocationInit"
      @isOffSiteLocationDataChange="handleOffSiteLocationFormDataChange"
      @formActionCompleted="handleOffSiteLocationFormActionCompleted"
      @onReset="handleOffSiteLocationFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="formShow && formAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import OffSiteLocationForm from '@/views/off-site-location/OffSiteLocationForm.vue'

export default {
  components: {
    OffSiteLocationForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['title_th'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      formShow: false,
      formAction: '',
      offSiteLocation: {},
      offSiteLocationInit: {},
      isOffSiteLocationDataChange: false,
      timeout: null,
      headers: [
        { text: 'ชื่อสถานที่', value: 'title_th' },
        { text: 'ชื่อสถานที่ (อังกฤษ)', value: 'title_en' },
        { text: 'ละติจูด', value: 'latitude' },
        { text: 'ลองจิจูด', value: 'longitude' },
        { text: 'timezone', value: 'timezone' },
      ],
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    markersInit() {
      return this.$store.state.googleMap.markersInit
    },
    offSiteLocations() {
      return this.$store.state.offSiteLocation.offSiteLocations
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'สถานที่ลงเวลานอกบริษัท',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchOffSiteLocations: 'offSiteLocation/fetchOffSiteLocations',
    }),
    classRowSelected(row) {
      if (
        this.offSiteLocation.offsite_location_uuid === row.offsite_location_uuid
      )
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::offsite_location:get')) {
        this.dialogForbidden = true
        return
      }

      if (
        this.offSiteLocation.offsite_location_uuid === row.offsite_location_uuid
      ) {
        this.formShow = false
        this.formAction = ''
        this.offSiteLocation = {}
        this.offSiteLocationInit = {}

        this.$store.commit('googleMap/SET_MARKERS', [])
        this.$store.commit('googleMap/SET_MARKERS_INIT', [])
      } else {
        this.formShow = true
        this.formAction = 'edit'
        this.offSiteLocation = { ...row }
        this.offSiteLocationInit = { ...row }

        const markers = []
        const latLng = {
          lat: parseFloat(row.latitude),
          lng: parseFloat(row.longitude),
        }
        markers.push({
          position: latLng,
        })
        this.$store.commit('googleMap/SET_MAP_CENTER', latLng)
        this.$store.commit('googleMap/SET_MARKERS', markers)
        this.$store.commit('googleMap/SET_MARKERS_INIT', markers)
      }
    },
    handleRowSelected(row) {
      if (this.isOffSiteLocationDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddForm() {
      this.formShow = true
      this.formAction = 'add'
      this.offSiteLocation = { timezone: '+07:00' }
      this.offSiteLocationInit = { timezone: '+07:00' }

      this.$store.commit('googleMap/SET_MARKERS', [])
      this.$store.commit('googleMap/SET_MARKERS_INIT', [])
    },
    handleOffSiteLocationFormDataChange(value) {
      this.isOffSiteLocationDataChange = value
    },
    handleOffSiteLocationFormReset(formAction) {
      if (formAction === 'edit')
        this.$store.commit(
          'googleMap/SET_MARKERS',
          JSON.parse(JSON.stringify(this.markersInit))
        )
      this.offSiteLocation = {
        ...this.offSiteLocationInit,
      }
    },
    handleOffSiteLocationFormActionCompleted(formAction) {
      this.offSiteLocation = {}
      this.offSiteLocationInit = {}

      this.$store.commit('googleMap/SET_MARKERS', [])
      this.$store.commit('googleMap/SET_MARKERS_INIT', [])

      this.formShow = false
      this.formAction = ''
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        params: {
          dpc: 'time-attendance-off-site-location-to-list-time-attendance-off-site-location',
        },
      }
      this.fetchOffSiteLocations(payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.$store.commit('googleMap/SET_MARKERS', [])
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.formShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isOffSiteLocationDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
